import React, { forwardRef } from "react";
import { IMaskInput } from "react-imask";

type FixRuleDaysChangeEvent = {
    target: {
        name: string;
        value: string;
    }
}

type FixRuleDaysProps = Omit<React.ComponentProps<typeof IMaskInput>,
    "onAccept" | "inputRef" | "mask" | "definitions" | "placeholder" | "overwrite" | "value"
> & {
    name: string;
    value?: string | number | null;
    onChange: (event: FixRuleDaysChangeEvent) => void;
};

export const FixRuleDays = forwardRef<HTMLInputElement, FixRuleDaysProps>(({ name, onChange, value, ...props }, ref) => {
    const normalizedValue = value == null ? "" : String(value);

    return (
        <IMaskInput
            {...props}
            value={normalizedValue}
            mask="000"
            definitions={{
                '0': /[0-9]/
            }}
            placeholder='0'
            inputRef={ref}
            onAccept={((nextValue: string | undefined) => onChange({ target: { name, value: String(nextValue ?? "") } }))}

            overwrite
        />
    );
});